export default "__VITE_ASSET__QX7VbYth__"